import { ViewState } from "@/interfaces/ViewState";

export default {
  namespaced: true,
  state: {},
  mutations: {
    updateViewState(state: any, viewState: ViewState) {
      state[viewState.name] = viewState.value;
    },
    clearViewState(state: any) {
      state = {};
    }
  }
};
